export {IconComponent} from './icon.component';
export {IconModule} from './icon.module';
export * from './icon.providers';
export * from './icon';
